/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");

export const ONE = require("./res/images/1.jpeg");
export const TWO = require("./res/images/2.jpeg");
export const THREE = require("./res/images/3.jpeg");
export const FOUR = require("./res/images/4.jpeg");
export const FIVE = require("./res/images/5.jpeg");
export const SIX = require("./res/images/6.jpeg");
export const SEVEN = require("./res/images/7.jpeg");
export const EIGHT = require("./res/images/8.jpeg");

export const SPORTS = require("./res/images/sports.jpg");

export const VIRAT = require("./res/images/1-virat.png");
export const SACHIN = require("./res/images/2-tendulkar.png");
export const CHRIS = require("./res/images/3-chris-gayle.png");
export const GARY = require("./res/images/4-gary.png");
export const SHANE = require("./res/images/5-shane.png");
export const STAR_WARS = require("./res/images/star-wars-1.png");

export const GOLD_ICON = require('./res/images/gold.png');
export const PLATINUM_ICON = require('./res/images/platinum-1.png');
export const DIAMOND_ICON = require('./res/images/diamond.png');

export const MS_DHONI = require('./res/images/ms-dhoni.jpg');
export const AB_DE_VILLIERS = require('./res/images/ab-de-villiers.jpg');
export const JOE_ROOT = require('./res/images/joe-root.jpg');
export const RICKY_PONTING = require('./res/images/ricky-ponting.jpg');
export const DAVID_WARNER = require('./res/images/david-warner.jpg');

export const LOADING_IMAGE = require('./res/images/loading-img.png');

export const WORLD_CUP = require('./res/images/cricket-world-cup.png');
export const KOHLI_LAMBORGINI = require('./res/images/kohli-lamborgini.png');
export const BRIAN_LARA_ERA = require('./res/images/brian-lara-era.png');

export const EMPTY_IMAGE = require('./res/images/empty.png'); 
export const SPORTS_IMG  = require('./res/images/sports.jpg');

export const SOUND = require('./res/images/sound.png');
export const Image_3D =  require('./res/images/3D_image.png');
export const musicButton =  require('./res/images/music-button.png');
export const videoButton =  require('./res/images/video-button.png');
export const button3D =  require('./res/images/3d-button.png');

export const SRIKANTH = require('./res/images/ssrikanth-1.png');

export const NO_ASSET = require('./res/images/no-data.svg');

export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,

    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX,
    SEVEN,
    EIGHT,
    SPORTS,

    VIRAT,
    SACHIN,
    CHRIS,
    GARY,
    SHANE,

    STAR_WARS,

    GOLD_ICON,
    PLATINUM_ICON,
    DIAMOND_ICON,

    MS_DHONI,
    AB_DE_VILLIERS,
    JOE_ROOT,
    RICKY_PONTING,
    DAVID_WARNER,
    
    LOADING_IMAGE,
    WORLD_CUP,
    KOHLI_LAMBORGINI,
    BRIAN_LARA_ERA,
    EMPTY_IMAGE,

    SPORTS_IMG,
    SRIKANTH,
    NO_ASSET
];
